<script>
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';
import RbxExtendedTextarea from '../../../shared/reybex/extendedTextarea/RbxExtendedTextarea';

export default {
  name: 'MasterDataForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
    RbxExtendedTextarea,
  },
  props: {
    tom: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    cleanResponsibleAffiliate() {
      this.tom.responsibleAffiliate = null;
    },
  },
};
</script>

<template>
  <v-form>
    <v-container fluid grid-list-lg pt-2 pa-0>
      <v-layout row wrap>
        <v-flex xs6 md4 py-0>
          <v-text-field
            v-model="tom.name"
            label="Bezeichnung"
            height="22"
            class="caption"
          />
        </v-flex>

        <v-flex xs6 md4 py-0>
          <rbx-remote-combobox
            v-model="tom.examState"
            label="Status"
            :selected="tom.examState"
            domain="ExamState"
          />
        </v-flex>

        <v-flex xs6 md4 py-0/>

        <v-flex xs6 md4 py-0>
          <rbx-remote-combobox
            v-model="tom.responsibleUser"
            label="Bearbeiter"
            :selected="tom.responsibleUser"
            domain="User"
          />
        </v-flex>

        <v-flex xs6 md2 py-0>
          <rbx-remote-combobox
            v-model="tom.responsibleAffiliate"
            label="Verantwortlicher"
            :selected="tom.responsibleAffiliate"
            :disabled="tom.isClientRespAffiliate"
            domain="Affiliate"
          />
        </v-flex>

        <v-flex xs6 md2 py-0>
          <v-checkbox
            v-model="tom.isClientRespAffiliate"
            label="Mandant selbst verantwortlich"
            class="caption"
            @click.native="cleanResponsibleAffiliate"
            hide-details
          />
        </v-flex>

        <v-flex xs6 md4 py-0>
          <rbx-remote-combobox
            v-model="tom.organizationalUnit"
            label="Organisationseinheit"
            :selected="tom.organizationalUnit"
            domain="OrganizationalUnit"
          />
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-textarea
            v-model="tom.measureNotes"
            label="Notwendige Maßnahmenbeschreibungen"
            class="caption"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>
